export function createSearchParams(params, {
  nonNull = true,
  nonUndefined = true,
  nonNaN = true,
} = {}) {
  let output = Object.keys(params)
    .filter(x => (!nonNull || params[x] !== null) && (!nonUndefined || params[x] !== undefined) && (!nonNaN || !isNaN(params[x])))
    .map(x => `${x}=${params[x]}`)
    .join('&');

  return output ? '?' + output : '';
}
